<template>
  <div>
    <div>
      <section class="top-fixing">
        <section class="common-sub-top container">
          <section class="top-info-wrap">
            <div class="prev-wrap">
              <a @click="pageBefore()" class="prev"></a>
              <span v-if="ptntInfo.ptntNm !== ''">
                <span class="name-wrap">
                  <span class="name">{{ ptntInfo.ptntNm }}</span>
                  <!-- <strong>님</strong>의 차트 (급여) {{ this.$route.params.selectedInfo }} -->
                </span>
              </span>
              <!-- TODO : 어디로 이동하는지 설정 필요 -->
              <template v-if="this.$route.params.btnViewYn === 'Y'">
                <span class="chart-change" @click="movePatientChartInfo()">비급여차트보기</span>
              </template>
            </div>
          </section>
        </section>
      </section>

      <!-- 간격 조정용 -->
      <div class="space-agree2"></div>
      <!-- //간격 조정용 -->

      <!-- 컨텐츠-->
      <section class="contents">
        <div class="tbl-wrap">
          <table class="info-tbl">
            <colgroup>
              <col width="130" />
              <col width="*" />
              <col width="130" />
              <col width="*" />
            </colgroup>
            <tr>
              <td>환자명</td>
              <td>{{ ptntInfo.ptntNm }}</td>
              <td>성별/나이</td>
              <td>
                <template v-if="ptntInfo.sex === 'M'"> 남성 </template>
                <template v-else> 여성 </template>/{{ ptntInfo.age }}
              </td>
            </tr>
            <tr>
              <td>환자번호</td>
              <td>{{ ptntInfo.ptntNo }}</td>
              <td>생년월일</td>
              <td>
                <template v-if="ptntInfo.prsnNo.length == 13">
                  {{ `${ptntInfo.prsnNo.substr(0, 2)}.${ptntInfo.prsnNo.substr(2, 2)}.${ptntInfo.prsnNo.substr(4, 2)}` }}
                </template>
              </td>
            </tr>

            <template v-if="opdMemoViewYn === 'Y'">
              <tr>
                <td>특이사항</td>
                <td colspan="3" style="text-align: left; padding: 0.3em">
                  <template v-if="ptntInfo.opdMemo != null">
                    <div v-if="ptntInfo.opdMemo.length < 50">
                      {{ ptntInfo.opdMemo }}
                    </div>
                    <div v-else>
                      <span>{{ ptntInfo.opdMemo.substr(0, 300) }}</span>
                      <button @click="clickLongText2({ title: '특이사항', msg: ptntInfo.opdMemo })" class="test">더보기</button>
                    </div>
                  </template>
                </td>
              </tr>
            </template>
          </table>
        </div>

        <div v-for="(item, idx) in ptntInfo.allergy" :key="idx">
          <h2 class="mt16"><i class="special"></i>{{ item.regNm }}</h2>
          <div class="mt15 memo">{{ item.msg }}</div>
        </div>
      </section>

      <section class="diagnosis-wrap">
        <h1>
          <!-- TODO : 가장 최근에 진료한 차트 가져오기-->
          최근 진료일 {{ this.selectVisitItem.clinicYmd.substr(0, 4) }}.{{ this.selectVisitItem.clinicYmd.substr(5, 2) }}.{{ this.selectVisitItem.clinicYmd.substr(8, 2) }}
          <!-- 최근 진료일 {{ this.selectVisitItem.clinicYmd.substr(0,4). }} -->
          <!--{{ selectVisitItem }} -->
          <button @click="whenVisited" class="btn-change-date">진료일 변경</button>
        </h1>
        <div class="tbl-wrap">
          <table>
            <colgroup>
              <col width="120" />
              <col width="*" />
              <col width="120" />
              <col width="120" />
              <col width="120" />
              <col width="120" />
            </colgroup>
            <tr>
              <td>최대처방일</td>
              <td>처방종료일까지 남은 날짜</td>
              <td>초/재진</td>
              <td>입원/외래</td>
              <td>보험구분</td>
              <td>의사명</td>
            </tr>
            <tr class="word-break">
              <td>{{ this.selectVisitItem.maxOrder }}일</td>
              <td>
                <template v-if="this.selectVisitItem.leftDays != ''"> {{ this.selectVisitItem.leftDays }}일</template>
                <template v-else> -</template>
              </td>
              <td>
                <template v-if="this.selectVisitItem.firstVisit != ''"> {{ this.selectVisitItem.firstVisit }}</template>
                <template v-else> -</template>
              </td>
              <td>{{ this.selectVisitItem.adm }}</td>
              <td>{{ this.selectVisitItem.insrGb }}</td>
              <td>{{ this.selectVisitItem.doctorNm }}</td>
            </tr>
          </table>
        </div>
      </section>

      <section class="symp-wrap content-wrap">
        <div class="header mt30">
          <h2>증상</h2>
        </div>
        <div class="symp-content" v-if="sympItem[0].sympTxt !== undefined">
          <div v-html="sympItem[0].sympHtml">
            {{ sympItem[0].sympHtml }}
          </div>

          <template v-if="viewSympBtn">
            <div style="height: 70px"></div>
            <button class="btn-symp1" @click="clickSympView" v-if="viewSympMore">더보기</button>
            <button class="btn-symp2" @click="clickSympView" v-else>접기</button>
          </template>
        </div>
        <div v-else class="symp-nodata mt30">증상 데이터가 없습니다</div>
      </section>

      <section class="list-wrap content-wrap">
        <div class="header mt30">
          <h2>상병</h2>
        </div>

        <div class="list-tbl-wrap">
          <table class="list-tbl mt30">
            <colgroup>
              <col width="5px" />
              <col width="11%" />
              <col width="91%" />
              <col width="5px" />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>코드</th>
                <th>코드명</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="diagItems != null">
                <tr v-for="(item, idx) in diagItems" :key="idx" class="word-break">
                  <td></td>
                  <td>{{ item.diagCd }}</td>
                  <td class="left">
                    <template v-if="item.diagType != ''"> [{{ item.diagType }}] </template>
                    <template v-if="item.ruleOut != ''"> [{{ item.ruleOut }}] </template>
                    {{ item.diagNm }}
                  </td>
                  <td></td>
                </tr>
              </template>
              <template v-else>
                <tr class="background-transparent">
                  <td colspan="5" class="nodata">상병 내역이 없습니다</td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </section>

      <section class="list-wrap content-wrap border0">
        <div class="header mt30">
          <h2>처방</h2>
        </div>

        <div class="list-tbl-wrap">
          <table class="list-tbl mt30">
            <colgroup>
              <col width="5px" />
              <col width="11%" />
              <col width="30%" />
              <col width="11%" />
              <col width="15%" />
              <col width="10%" />
              <col width="5%" />
              <col width="5%" />
              <col width="15%" />
              <col width="5px" />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>코드</th>
                <th>코드명</th>
                <th>용법</th>
                <th>급여구분</th>
                <th>투여량</th>
                <th>횟수</th>
                <th>일수</th>
                <th>결과</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-if="orderItems != null">
                <tr v-for="(item, idx) in orderItems" :key="idx" class="word-break">
                  <td></td>
                  <td>{{ item.userCd }}</td>
                  <td>{{ item.userNm }}</td>
                  <td>{{ item.methodNm }}</td>
                  <td>{{ item.ediNm }}</td>
                  <td>{{ item.qty }}</td>
                  <td>{{ item.divide }}</td>
                  <td>{{ item.days }}</td>
                  <td class="preview">
                    <div v-if="item.labResult.trim().length <= 9">
                      {{ item.labResult }}
                    </div>

                    <div v-else>
                      <span class="the">{{ item.labResult }}</span>
                      <input type="checkbox" name="preview" :disabled="item.labResult.trim().length === 0" :id="`labResult${idx}`" @click="clickLongText($event)" />
                      <label :for="`labResult${idx}`">더보기</label>
                      <div>
                        <span @click="clickLongTextClose(`labResult${idx}`)"></span>
                        <h2>결과</h2>
                        <div class="text">
                          {{ item.labResult }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td></td>
                </tr>
              </template>
              <template v-else>
                <tr class="background-transparent">
                  <td colspan="10" class="nodata">처방 내역이 없습니다</td>
                </tr>
              </template>
            </tbody>
          </table>
          <br /><br />
        </div>
      </section>
      <!-- //컨텐츠-->

      <VisitItemList :visitItems="visitItems" @sendItem="getItem" />
    </div>
    <div v-show="renderFlag === 'N'"><loading-component></loading-component></div>
    <section class="view-quick-menu">
      <button @click="openPenChartMenu">
        <img :src="require('@/assets/img/common/quick-menu.png')" alt="" />
      </button>
    </section>

    <!-- 환자 클릭시 메뉴 정보 모달 -->
    <PenChartMenu :selectedInfo="$route.params.selectedInfo" />
    <LongTextPopup ref="longTextPopupRef" :propData="propData" />
  </div>
</template>

<script>
import VisitItemList from '@/components/popup/VisitItemList';
import { popOpenAndScrollNone } from '@/utils/UtilPopup';
import Loading from '../../components/loading/Loading';
import PenChartMenu from '@/components/popup/PenChartMenu';
import LongTextPopup from '@/components/popup/LongTextPopup';

export default {
  components: {
    VisitItemList,
    'loading-component': Loading,
    PenChartMenu,
    LongTextPopup
  },
  data: () => ({
    debugInfo: [],
    receptNo: '',
    date: '',
    opdMemoViewYn: '',
    selectVisitItem: {
      adm: '',
      clinicYmd: '',
      doctorNm: '',
      firstVisit: '',
      insrGb: '',
      leftDays: '',
      maxOrder: '',
      receptNo: ''
    },
    getVisitItem: {
      adm: '',
      clinicYmd: '',
      doctorNm: '',
      firstVisit: '',
      insrGb: '',
      leftDays: '',
      maxOrder: '',
      receptNo: ''
    },
    ptntInfo: {
      ptntNm: '',
      phoneNo: '',
      tenNo: '',
      prsnNo: ''
    },
    visitItems: null,
    visitDetail: null,
    orderItems: null,
    diagItems: null,
    sympItem: [
      {
        sympHtml: ''
      }
    ],
    viewIndex: 0,
    reserveCnt: 0,
    consultCnt: 0,
    procedureCnt: 0,
    procedureRemarkCnt: 0,
    paymentCnt: 0,
    selectStatus: '',
    selectInsrDiv: '',
    viewSympBtn: false,
    viewSympMore: true,
    renderFlag: 'N',
    checkFirstClinicYmd: 'Y',
    propData: { title: '', msg: '', id: 'longText' }
  }),
  async mounted() {
    this.receptNo = this.$route.params.receptNo;
    this.date = this.$route.params.date;
    this.opdMemoViewYn = this.$store.state.settingInfo.opdMemoViewYn;

    try {
      //환자 정보
      let url = `/ptnt/ptntInfo/${this.$route.params.selectedInfo.ptntNo}`;
      if (this.$osType === 'web' || this.$osType === 'ios') {
        await this.$axios
          .get(url)
          .then((response) => {
            this.ptntInfo = response.data.data;
            this.ptntInfo.phoneNo = this.$util.convPhoneNoHypen(this.ptntInfo.phoneNo);
            this.ptntInfo.telNo = this.$util.convPhoneNoHypen(this.ptntInfo.telNo);
            this.debugInfo.push({
              response
            });
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        let result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
        this.ptntInfo = result.data;
        this.ptntInfo.phoneNo = this.$util.convPhoneNoHypen(this.ptntInfo.phoneNo);
        this.ptntInfo.telNo = this.$util.convPhoneNoHypen(this.ptntInfo.telNo);
        this.debugInfo.push({
          result
        });
      }

      //진료리스트
      url = `/eghis/visitdays/${this.$route.params.ptntNo}`;
      if (this.$osType === 'web' || this.$osType === 'ios') {
        await this.$axios
          .get(url)
          .then((response) => {
            this.visitItems = response.data.data;
            if (this.$store.state.debugModeFlag) {
              this.debugInfo.push({
                response
              });
            }

            if (this.visitItems == null) {
              this.visitItems = [{}];
              this.selectVisitItem = {
                adm: '-',
                clinicYmd: '-',
                doctorNm: '-',
                firstVisit: '-',
                insrGb: '-',
                leftDays: '-',
                maxOrder: '-',
                receptNo: '-'
              };
            } else {
              var tempReceptNo = this.$route.params.selectedInfo.receptNo;
              var tempClinicYmd = this.$route.params.selectedInfo.clinicYmd;
              this.visitItems.forEach((e) => {
                e.clinicYmd = this.$util.convYmd(e.clinicYmd, '-');
                if (e.clinicYmd.replace(/-/gi, '') === tempClinicYmd && e.receptNo === tempReceptNo) {
                  console.log(e);
                  this.selectVisitItem = e;
                  this.getItem(this.selectVisitItem);
                }
              });
              //진료일 최근값 세팅
              //this.selectVisitItem = this.visitItems[0];
              //this.getItem(this.selectVisitItem);
            }
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        let result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
        this.visitItems = result.data;
        if (this.$store.state.debugModeFlag) {
          this.debugInfo.push({
            result
          });
        }

        if (this.visitItems == null) {
          this.visitItems = [{}];
          this.selectVisitItem = {
            adm: '-',
            clinicYmd: '-',
            doctorNm: '-',
            firstVisit: '-',
            insrGb: '-',
            leftDays: '-',
            maxOrder: '-',
            receptNo: '-'
          };
        } else {
          var tempReceptNo = this.$route.params.selectedInfo.receptNo;
          var tempClinicYmd = this.$route.params.selectedInfo.clinicYmd;
          this.visitItems.forEach((e) => {
            e.clinicYmd = this.$util.convYmd(e.clinicYmd, '-');
            if (e.clinicYmd.replace(/-/gi, '') === tempClinicYmd && e.receptNo === tempReceptNo) {
              this.selectVisitItem = e;
              this.getItem(this.selectVisitItem);
            }
          });
          //진료일 최근값 세팅
          //this.selectVisitItem = this.visitItems[0];
          //this.getItem(this.selectVisitItem);
        }
      }

      this.renderFlag = 'Y';

      //예약,취소,입원 환자일 경우 팝업띄워줌.
      if (this.$route.params.selectedInfo.procNm == '예약' || this.$route.params.selectedInfo.procNm == '접수취소' || this.$route.params.selectedInfo.procNm == '입원') {
        this.whenVisited();
      }
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    pageBefore() {
      this.$router
        .push({
          name: '대기리스트',
          params: {
            selectDept: this.$route.params.selectDept,
            searchKeyword: this.$route.params.searchKeyword,
            selectYYYY: this.$route.params.selectYYYY,
            selectDate: this.$route.params.selectDate,
            activeTab: this.$route.params.activeTab
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    procColor(str) {
      let color = '';
      if (str === '접수' || str === '접수취소') {
        color = 'receipt';
      } else if (str === '접수대기') {
        color = 'wait';
      } else if (str === '진료중') {
        color = 'diagnosis';
      } else if (str === '진료보류' || str === '접수대기') {
        color = 'hold';
      } else if (str === '진료완료') {
        color = 'diagnosis';
      } else if (str === '예약' || str === '예약취소') {
        color = 'reserve';
      } else if (str === '보류') {
        color = 'compensation';
      } else if (str === '수납완료') {
        color = 'storecom';
      } else if (str === '입원') {
        color = 'admission';
      } else if (str === '퇴원') {
        color = 'discharge';
      }
      return color;
    },
    getItem(item) {
      this.selectVisitItem = item;

      //진료 정보
      let url = `/eghis/treatmentInfo/${item.receptNo}/${this.$util.convYmd(item.clinicYmd, '')}/${this.$store.state.storeUserId}`;

      try {
        if (this.$osType === 'web' || this.$osType === 'ios') {
          this.$axios
            .get(url)
            .then((response) => {
              this.debugInfo.push({
                response
              });

              this.orderItems = response.data.data.order;

              this.diagItems = response.data.data.diag;
              this.sympItem = response.data.data.symp;

              if (this.sympItem == null) {
                this.sympItem = [{ sympHtml: '' }];
              } else {
                // 현재 사용은 배열 [0]만 사용하므로 다음과 같이 처리

                // 1. body 안에 있는 태그와 문구 가져오기
                let __symp = this.sympItem[0].sympHtml;
                __symp = __symp.split('<body>');
                __symp = __symp[1].split('</body>');
                __symp = __symp[0];

                if (this.sympItem[0].sympTxt > 200 || __symp.match(/<p>/g).length > 7) {
                  this.viewSympBtn = true;
                }

                // 2. 태그와 문구를 div에 담기
                const __temp = document.createElement('div');
                __temp.innerHTML = __symp;
                __temp.id = 'temp';

                // 3. 담은 태그 span에 있는 글꼴 관련 스타일 제거하기
                const __tempDom = __temp.querySelectorAll('span');
                __tempDom.forEach((e) => {
                  e.style.fontSize = 'inherit';
                  e.style.fontFamily = 'inherit';
                });
                // console.log(__temp.innerHTML);

                this.sympItem[0].sympHtml = __temp.innerHTML; // this.sympItem[0].sympHtml.replace(/(<([^>]+)>)/gi, '');
              }
            })
            .catch((e) => {
              console.log(e);
            });
          this.selectVisitItem.clinicYmd = this.selectVisitItem.clinicYmd.replace('-', '.').replace('-', '.');
        } else {
          let result = this.$util.getApi(`${this.$store.state.apiDomain}${url}`);
          this.debugInfo.push({
            result
          });
          this.orderItems = result.data.order;
          this.diagItems = result.data.diag;
          this.sympItem = result.data.symp;

          if (this.sympItem == null) {
            this.sympItem = [{ sympHtml: '' }];
          } else {
            // 현재 사용은 배열 [0]만 사용하므로 다음과 같이 처리
            // 1. body 안에 있는 태그와 문구 가져오기
            let __symp = this.sympItem[0].sympHtml;
            __symp = __symp.split('<body>');
            __symp = __symp[1].split('</body>');
            __symp = __symp[0];

            if (this.sympItem[0].sympTxt > 200 || __symp.match(/<p>/g).length > 7) {
              this.viewSympBtn = true;
            }

            // 2. 태그와 문구를 div에 담기
            const __temp = document.createElement('div');
            __temp.innerHTML = __symp;
            __temp.id = 'temp';

            // 3. 담은 태그 span에 있는 글꼴 관련 스타일 제거하기
            const __tempDom = __temp.querySelectorAll('span');
            __tempDom.forEach((e) => {
              e.style.fontSize = 'inherit';
              e.style.fontFamily = 'inherit';
            });
            // console.log(__temp.innerHTML);

            this.sympItem[0].sympHtml = __temp.innerHTML; // this.sympItem[0].sympHtml.replace(/(<([^>]+)>)/gi, '');
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    //비급여차트 이동
    movePatientChartInfo() {
      this.$router
        .push({
          name: '환자차트정보(CRM)',
          params: {
            ptntNo: this.$route.params.ptntNo,
            receptNo: this.$route.params.receptNo,
            selectedInfo: this.$route.params.selectedInfo
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 증상 접기, 더보기
    clickSympView() {
      this.viewSympMore = !this.viewSympMore;

      const el = document.querySelector('.symp-content');

      if (!this.viewSympMore) {
        el.style.maxHeight = 'initial';
      } else {
        el.style.maxHeight = '250px';
      }
    },
    // 진료일 변경 클릭 시 팝업
    whenVisited() {
      popOpenAndScrollNone('#visitMark', '#visitList');
    },
    openPenChartMenu() {
      // 팝업 띄우기
      popOpenAndScrollNone('#dimPenChartMenu .dim-popup-mark', '#dimPenChartMenu .dim-popup-content');
    },
    // 보기 클릭
    clickLongText(e) {
      const target = e.target;
      const chkDoms = document.querySelectorAll(`input[name=${target.name}]`);
      const baseChecked = target.checked;

      chkDoms.forEach((element) => {
        element.checked = false;
      });

      if (baseChecked) {
        target.checked = true;
      }
    },
    clickLongTextClose(id) {
      const popDom = document.querySelector(`#${id}`);
      popDom.checked = false;
    },
    clickLongText2(obj) {
      this.propData.title = obj.title;
      this.propData.msg = obj.msg;

      this.$refs.longTextPopupRef.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.test {
  margin-left: 1em;
  padding: 0px 6px;
  font-size: 1.4rem;
  font-family: 'NotoBold';
  color: #ff655a;
  text-align: left;
  background-color: #fff;
  border: 1px solid #ff655a;
  border-radius: 3px;
}
.left {
  text-align: left !important;
}
.list-wrap {
  padding: 0 17px 30px;
  & .list-tbl-wrap {
    overflow: hidden;
    padding: 0px 0px 30px;
    & .more {
      padding: 20px 0;
      display: block;
      border: 1px solid #ff655a;
      background: #fff;
      border-radius: 6px;
      text-align: center;
      font-size: 1.6rem;
      color: #ff655a;
      font-weight: 700;
      & i {
        transform: rotate(90deg);
        display: inline-block;
        width: 13px;
        height: 12px;
        background-size: 100%;
        background: url('../../assets/images/ic_list_arrow.svg') no-repeat;
        margin-left: 10px;
        vertical-align: -4px;
      }
    }
    & table {
      & tr {
        & th {
          border-top: 1px solid #e0e0e0;
          border-bottom: 1px solid #e0e0e0;

          background: #fff;
          height: 45px;
          font-family: 'Noto Sans KR', sans-serif;
          font-size: 1.5rem;
          font-weight: 400;
          line-height: 1.8rem;
          color: #969696;
        }
        & td {
          text-align: center;
          // height: 84px;
          padding: 20px 0;
          font-size: 1.6rem;
          &.status {
            position: relative;
            & p {
              position: relative;
              display: inline-block;
              font-family: 'SCDream', sans-serif;
              color: #ffa71d;
              &:after {
                content: '';
                width: 100%;
                height: 5px;
                position: absolute;
                bottom: 0;
                left: 0;
                background: #ffa81d31;
              }
            }
          }
        }
        &:nth-child(odd) {
          & td {
            background: #fafafa;
          }
        }
      }
    }
  }
  & .header {
    display: flex;
    justify-content: space-between;
    & .pay-wrap {
      display: flex;
      & .total {
        position: relative;
        &:after {
          content: '';
          position: absolute;
          right: 0;
          top: 4px;
          height: 18px;
          width: 1px;
          background: #cccccc;
        }
      }
      & .type {
        font-size: 1.2rem;
        color: rgba(38, 38, 38, 0.6);
        margin-right: 20px;
      }
      & .pay {
        font-family: 'Roboto';
        font-size: 1.8rem;
      }
      & .won {
        font-size: 1.6rem;
        margin-left: 3px;
        &.green {
          padding-right: 23px;
        }
      }
      & .green {
        color: #29b48b;
      }
      & .red {
        color: #ff4366;
      }
    }
    & h2 {
      position: relative;
      font-size: 2rem;
      color: #000;
      font-weight: 700;
      padding-left: 30px;
      &:after {
        content: '';
        width: 6px;
        height: 6px;
        background: #000;
        border-radius: 50%;
        position: absolute;
        left: 11px;
        top: 11px;
      }
      & .fold {
        display: inline-block;
        font-size: 1.4rem;
        color: #888888;
        margin-left: 20px;
        font-weight: 400;
        & i {
          margin-left: 3px;
          vertical-align: 2px;
          display: inline-block;
          width: 11px;
          height: 7px;
          background: url('../../assets/images/ic_close_arrow.svg') no-repeat;
        }
      }
    }
    & .select-group {
      display: flex;
      & select {
        width: 150px;
        border-radius: 0;
        border-top: 0;
        border-left: 0;
        border-right: 0;
        border-bottom: 1px solid #000;
        margin-left: 15px;
      }
    }
  }
}
.common-sub-top {
  border-bottom: 0;
  padding: 0;
  & .top-info-wrap {
    border-bottom: 1px solid #e9e9e9;
  }
  & .prev-wrap {
    display: flex;
    width: 100%;
    padding: 20px;
    & .name {
      margin-left: 10px;
    }
    & .chart-change {
      flex-grow: 1;
      text-align: right;
      font-family: 'NotoBold';
      color: #ff6357;
    }
  }
}

.contents {
  padding: 27px 17px;
  border-bottom: 1px solid #dadada;

  & .tbl-wrap {
    border: 1px solid #cccccc;
    border-radius: 6px;
    overflow: hidden;
    & table {
      & tr {
        & td {
          font-size: 1.6rem;
          text-align: center;
          padding: 15px 0;
          border-bottom: 1px solid #cccccc;
          &:nth-child(odd) {
            background: #f4f4f4;
            font-family: 'NotoRagular';
          }
          &:nth-child(1),
          &:nth-child(2),
          &:nth-child(3) {
            border-right: 1px solid #ccc;
          }
        }
        &:last-child {
          & td {
            border-bottom: 0;
          }
        }
      }
    }
  }
  & h2 {
    font-size: 1.6rem;
    color: #999999;
    font-weight: 400;
    padding-left: 5px;
    & .person {
      display: inline-block;
      margin-right: 5px;
      vertical-align: -1px;
      width: 16px;
      height: 16px;
      background-size: 100%;
      background: url('../../assets/images/ic_memo_man.svg') no-repeat;
    }
    & .special {
      display: inline-block;
      margin-right: 5px;
      vertical-align: -3px;
      width: 16px;
      height: 18px;
      background-size: 100%;
      background: url('../../assets/images/ic_memo_allergy.svg') no-repeat;
    }
  }
  & .memo {
    background: #f4f4f4;
    border-radius: 6px;
    padding: 15px;
    height: 120px;
    overflow-y: auto;
    font-size: 1.8rem;
  }
}

.space-agree2 {
  height: 71px;
}

.diagnosis-wrap {
  padding: 0px 17px 27px;
  border-bottom: 12px solid #f4f4f4;

  & h1 {
    display: flex;
    align-items: center;
    margin: 20px 10px;
    font-family: 'NotoBold';
    font-size: 2.5rem;

    & .btn-change-date {
      margin-left: 20px;
      padding: 10px 20px;
      border: 1px solid #ccc;
      background-color: #fff;
      border-radius: 50px;
      font-size: 1.6rem;

      &:before {
        content: '';
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 10px;
        background: url('../../assets/img/common/ic-calendar-black.png') no-repeat;
        background-size: contain;
        vertical-align: -5px;
      }
    }
  }

  & .tbl-wrap {
    border: 1px solid #cccccc;
    border-radius: 6px;
    overflow: hidden;
    & table {
      & tr {
        &:nth-child(even) {
          background: #f4f4f4;
          font-family: 'NotoRagular';
        }
        & td {
          font-size: 1.6rem;
          text-align: center;
          padding: 15px 0;
          border-bottom: 1px solid #cccccc;
          border-right: 1px solid #cccccc;
          &:last-child {
            border-right: 0;
          }
        }
        &:last-child {
          & td {
            border-bottom: 0;
          }
        }
      }
    }
  }
}

.content-wrap {
  position: relative;
  padding: 0;
  border-bottom: 12px solid #f4f4f4;
  & .header {
    display: flex;
    justify-content: space-between;
    margin: 0 10px;
    & h2 {
      position: relative;
      font-size: 2rem;
      color: #000;
      font-weight: 700;
      padding-left: 30px;
      &:after {
        content: '';
        width: 6px;
        height: 6px;
        background: #000;
        border-radius: 50%;
        position: absolute;
        left: 17px;
        top: 11px;
      }
    }
  }
  &.border0 {
    border-bottom: 0px;
  }
}
.symp-wrap {
  & .symp-content {
    margin: calc(3rem - 20px) 25px 3rem 25px;
    font-size: 1.8rem;
    line-height: 2.8rem;
    color: #737373;
    max-height: 250px;
    overflow: hidden;

    & button {
      position: absolute;
      bottom: 15px;
      left: 15px;
      right: 15px;
      width: calc(100% - 30px);
      padding: 18px;
      font-size: 1.8rem;
      border-radius: 8px;
      font-family: 'NotoBold';
      background-color: #efefef;

      &::after {
        content: '';
        display: inline-block;
        width: 15px;
        height: 15px;
        background: url('../../assets/img/common/ic-sorting-black.png') no-repeat;
        background-size: contain;
        vertical-align: -5px;
        margin-left: 10px;
      }

      &.btn-symp2::after {
        background: url('../../assets/img/common/ic-up-black.png') no-repeat;
        background-size: contain;
      }
    }
  }

  & .symp-nodata {
    padding: 0 20px 50px;
    font-size: 1.6rem;
    text-align: center;
  }
}

.nodata {
  padding-top: 50px !important;
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.95rem;
}
/* Quick 메뉴 펜차트 */
.view-quick-menu {
  position: fixed;
  right: 20px;
  bottom: 20px;
}
.view-quick-menu button {
  background-color: transparent;
}
.view-quick-menu button img {
  width: 175px;
}

.word-break {
  word-break: break-all;
}

.preview {
  position: relative;

  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    span.the {
      display: block;
      width: 60px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  h2 {
    font-size: 2rem;
    color: #000;
    font-weight: 700;
  }
  input[name='preview'] {
    appearance: none;
  }
  input[name='preview'] + label {
    padding: 0px 6px;
    font-size: 1.2rem;
    font-family: 'NotoBold';
    color: #ff655a;
    text-align: left;
    border: 1px solid #ff655a;
    border-radius: 3px;
    background-color: #fff;
  }
  input[name='preview'] + label + div {
    display: none;
    width: 300px;
    top: -90%;
    right: 20px;
    z-index: 2;
    padding: 20px 24px;
    color: rgba(0, 0, 0, 0.7);
    text-align: left;
    border-radius: 5px;
    box-shadow: 0px 5px 20px 0 rgba(0, 0, 0, 0.1);
    border: solid 2px #e0e0e0;
    background-color: #fff;

    span {
      position: absolute;
      width: 15px;
      height: 15px;
      top: 25px;
      right: 24px;
      display: inline-block;
      background: url('~@/assets/img/common/ic-close.png') no-repeat;
      background-size: 15px;
    }
  }
  input[name='preview']:disabled + label {
    color: #ccc;
    border-color: #ccc;
  }
  input[name='preview']:checked + label {
    color: #fff;
    background-color: #ff655a;
  }
  input[name='preview']:checked + label + div {
    display: block;
    position: absolute;
  }
}
</style>
